import { Link } from "react-router-dom";
import conectaLogo from "../../../conecta.svg";

export function Brand({
  compact = false,
  link = true,
}: {
  compact?: boolean;
  link?: boolean;
}) {
  const content = (
    <img className="brand__logo" src={conectaLogo} alt="Conecta" />
  );

  if (!link) {
    return <span className={`brand ${compact ? "brand--compact" : ""}`}>{content}</span>;
  }

  return (
    <Link to="/" className={`brand ${compact ? "brand--compact" : ""}`} aria-label="Conecta, página inicial">
      {content}
    </Link>
  );
}
